
/**
 * EmailJS configuration
 */

export interface EmailJsConfig {
  publicKey: string;
  serviceId: string;
  adminTemplateId: string;
  customerTemplateId: string;
}

/**
 * Get EmailJS configuration from environment variables or fallback values
 */
export const getEmailJsConfig = (): EmailJsConfig => {
  return {
    publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || "LAc8Q83VEsaAsMj29",
    serviceId: import.meta.env.VITE_EMAILJS_SERVICE_ID || 'service_uqtvpm7',
    adminTemplateId: import.meta.env.VITE_EMAILJS_ADMIN_TEMPLATE_ID || 'template_b2s7ej7',
    customerTemplateId: import.meta.env.VITE_EMAILJS_CUSTOMER_TEMPLATE_ID || 'template_xmbafbm',
  };
};
